import React, { Component } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faComment } from '@fortawesome/free-solid-svg-icons';

/**
 * Composant Recherche contenant une barre (avec auto-complétion) et un bouton de recherche
 */
class Search extends Component {
    /**
     * Toutes les variables dont a besoin le Composant et qui seront modifiées à travers l'application (variables d'état)
     * @param {*} props 
     */
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
        this.simulateEnterKey = this.simulateEnterKey.bind(this);

        this.state = {
            results: [],
            input: "",
            searchResult: true,
            value: props.initialValue || []
        }
    }

    componentDidMount() {
        fetch('/api/connect/status')
        .then(response => {
            if (response.status !== 200) {
                // console.log('User pbbt pas encore connecté');
                return response.text();
            }
            return response.json();
        })
        .then(content => {
            if (content.connectStatus === 2) {
                this.setState({ showIa: true });
                // L'utilisateur vient de se connecter : on indique le bouton IA à cliquer
                if (sessionStorage.getItem('openIaAfterLogin') === 'true') {
                    this.setState({ justConnected: true });
                }
            }
          })
          .catch(error => console.error('Error fetching data:', error));
    }

    componentDidUpdate(prevProps) {
        if (prevProps.initialValue !== this.props.initialValue) {
            this.setState({ value: this.props.initialValue });
        }
    }

    /**
     * Fonction déclenchée au moment de la saisie d'un mot-clé dans la barre de recherche
     * @param {*} e : événement onInputChange
     * @param {*} value : valeur saisie par l'utilisateur dans la barre de recherche
     */
    onValueChangeSearch(e) {
        const value = e.target.value; // Accéder à la valeur de l'entrée
        this.state.input = value;
        //Appel de la fonction définie dans l'attribut onValueChange présente dans la page Home.js
        this.props.onValueChange(e, value);
    };

    // permet de prévalider la saisie comment si on appuyait sur la touche entrée
    simulateEnterKey() {
        const event = new KeyboardEvent('keydown', {
            key: 'Enter',
            code: 'Enter',
            keyCode: 13,
            which: 13,
            bubbles: true
        });
        document.querySelector('#free-solo-demo').dispatchEvent(event);
    }
    
    /**
     * Fonction déclenchée au moment de la recherche de fiches Mécathèque grâce au bouton de recherche
     * @param {*} e :  événement onClick
     */
    handleClick(e) {
        //Appel de la fonction définie dans l'attribut handleClick présente dans la page Home.js
        this.simulateEnterKey();
        //this.props.handleClick(this.state.input);
    }

    handleClickIA(e) {
        window.open('https://mecatheque.ai.cetim.fr/', '_blank');
        // On masque l'indication une fois que l'utilisateur a cliqué sur le bouton IA
        sessionStorage.removeItem('openIaAfterLogin');
        this.setState({ justConnected: false });
        if (this.props.onClickIa) {
            this.props.onClickIa('https://mecatheque.ai.cetim.fr/');
        }
    };

    closeHint = () => {
        sessionStorage.removeItem('openIaAfterLogin');
        this.setState({ justConnected: false });
    };

    /**
     * Fonction déclenchée au moment de la sélection de mots-clés
     * @param {*} e : évement onChange
     * @param {*} value : liste des mots-clés sélectionnées
     */
    selectValue(e, value) {
        //Appel de la fonction définie dans l'attribut selectValue présente dans la page Home.js
        this.state.input = value;
        this.props.selectValue(value);
    }

    /**
     * Rendu du Composant de recherche
     * @returns : template HTML avec les différents appels aux fonction JS
     */
    render() {
        // Permet d'accepter la case (sensitive : false, insensitive : true)
        // A mettre dans le composant Autcomplete ; filterOptions={filterOptions}
        const filterOptions = createFilterOptions({
            ignoreAccents: true,
            ignoreCase: true,
            //limit: 7,
        });

        return (
            <div className='col-sm-12 col-md-6 d-flex align-items-center'>
            <Autocomplete
                id="free-solo-demo"
                freeSolo
                onInputChange={this.onValueChangeSearch.bind(this)}
                onChange={this.selectValue.bind(this)}
                filterOptions={filterOptions}
                multiple
                isOptionEqualToValue={() => false} // fix problème si mots en doublons
                value={this.state.value} // Utiliser la valeur de l'état
                sx={{ width: 500 }}
                options={this.props.resultsES.map(option => option._source.expression)}
                renderInput={(params) => <TextField {...params} label="Rechercher" sx={{
                "& label.Mui-focused": {
                    color: '#CA0538'
                },
                "& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                    borderColor: '#CA0538'
                    }
                }
                }} />}
            />
            <button className="btn btn-primary bouton-recherche" onClick={this.handleClick.bind(this)} style={{ minWidth: 50 }}>
                <FontAwesomeIcon icon={faMagnifyingGlass} />
            </button>
            {this.state.showIa && (
                <button style={{ marginLeft: 10, minWidth: 50 }} className="btn btn-primary bouton-recherche" onClick={this.handleClickIA.bind(this)}>
                    <img src="./images/picto-ia.png" alt="IA Icon" style={{ height: '100%', margin: '-10px' }} />
                </button>
            )}
            {this.state.showIa && this.state.justConnected && (
                <div className="ia-hint">
                    Vous êtes connecté&nbsp;! Cliquez ici pour accéder à l'<span style={{ color: '#EF3346', fontWeight: 'bold' }}>IA générative</span>.
                    <span className="ia-hint-close" role="button" aria-label="Fermer" onClick={this.closeHint}>&times;</span>
                </div>
            )}
            </div>
        )
    }
}

export default Search;